// @docs https://[domain]/api/v1/docs
export default {
  List: "/pyr/requests",
  Create: "/pyr/requests",
  Update: "/pyr/requests",
  Detail: "/pyr/requests",
  Approve: "/pyr/requests/approve",
};
